import React, { FC } from 'react';

interface Props {
  text: string;
  fromApp?: string;
  url: string;
  title: string;
  className: string;
  openInNewWindow?: boolean;
}

const QuickLink: FC<Props> = ({
  text,
  fromApp,
  url,
  title,
  className,
  children,
}) => {
  const getHref = () => {
    if (fromApp === null || fromApp === undefined) {
      return url;
    }
    return `${process.env.REACT_APP_API}/clienteLogado/getTK?fromUrl=${url}&fromApp=${fromApp}`;
  };
  return (
    <>
      <li className={`f2-quicklinks__item ${className}`}>
        <a href={getHref()} title={title} className="f2-quicklinks__content">
          <p className="f2-quicklinks__text">{text.toUpperCase()}</p>
          {children}
        </a>
      </li>
    </>
  );
};

export default QuickLink;
